export default "__VITE_ASSET__BiRYSpdh__"